import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Home } from '../pages/Home'
import { NotFound } from '../pages/NotFound'
import NavBar from '../components/NavBar'
import PrivateRouter from './PrivateRoute'
import EtikRoute from './EtikRoute'
import RamakKalaRoute from './RamakKalaRoute'
import OdulOneriIkRoute from './OdulOneriIkRoute'
import OdulOneriManagerRoute from './OdulOneriManagerRoute'
import OdulOneriOpexRoute from './OdulOneriOpexRoute'
import ReportPermissionRoute from './ReportPermissionRoute'
import Login from '../pages/Login'
import Tesekkur from '../pages/Tesekkur'
import Sikayet from '../pages/Sikayet'
import OneriTalep from '../pages/OneriTalep'
import RamakKala from '../pages/RamakKala'
import Etiklik from '../pages/Etiklik'
import AccessDenied from '../pages/AccessDenied'
import YoneticiDegerlendirme from '../pages/odul-oneri/YoneticiDegerlendirme'
import YoneticiDashboard from '../pages/odul-oneri/YoneticiDashboard'
import IKTakipRapor from '../pages/odul-oneri/IKTakipRapor'
import IKConfig from '../pages/odul-oneri/IKConfig'
import KurulToplantisi from '../pages/odul-oneri/KurulToplantisi'
import OpexOnFiltreleme from '../pages/odul-oneri/OpexOnFiltreleme'
import OpexUygulamaTakip from '../pages/odul-oneri/OpexUygulamaTakip'
import OdulOneriBasvuruPage from '../pages/odul-oneri/OdulOneriBasvuruPage'
import UygulamaTokenRedirect from '../pages/odul-oneri/UygulamaTokenRedirect'
import ErisimYonetimi from '../pages/yonetim/ErisimYonetimi'
import { REPORT_KEYS } from '../helper/accessControlConstants'

export const AppRouter = () => (
  <>
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="access-denied" element={<AccessDenied />} />

        <Route path="odul-oneri/basvuru" element={<OdulOneriBasvuruPage />} />
        {/* Eski lider linkleri → e-posta oturumu + opex-takip */}
        <Route path="odul-oneri/uygulama/:token" element={<UygulamaTokenRedirect />} />
        <Route path="odul-oneri/yonetici/:token" element={<YoneticiDegerlendirme />} />
        {/* Hesap zorunlu değil; sayfa Firebase / e-posta oturumunu kendisi çözer */}
        <Route path="odul-oneri/opex-takip" element={<OpexUygulamaTakip />} />
        <Route path="odul-oneri/opex-filtre" element={<OpexOnFiltreleme />} />

        <Route path="yonetim" element={<PrivateRouter />}>
          <Route path="erisim" element={<ErisimYonetimi />} />
        </Route>

        <Route path="report" element={<PrivateRouter />}>
          <Route element={<ReportPermissionRoute reportKey={REPORT_KEYS.TESEKKUR} />}>
            <Route path="tesekkur" element={<Tesekkur />} />
          </Route>
          <Route element={<ReportPermissionRoute reportKey={REPORT_KEYS.SIKAYET} />}>
            <Route path="sikayet" element={<Sikayet />} />
          </Route>
          <Route element={<ReportPermissionRoute reportKey={REPORT_KEYS.ONERITALEP} />}>
            <Route path="oneritalep" element={<OneriTalep />} />
          </Route>
        </Route>

        <Route path="report" element={<RamakKalaRoute />}>
          <Route path="ramakkala" element={<RamakKala />} />
        </Route>

        <Route path="report" element={<EtikRoute />}>
          <Route path="etiklik" element={<Etiklik />} />
        </Route>

        <Route element={<OdulOneriManagerRoute />}>
          <Route path="odul-oneri/yonetici-panel" element={<YoneticiDashboard />} />
        </Route>

        <Route element={<OdulOneriOpexRoute />}>
          <Route path="odul-oneri/kurul-toplanti" element={<KurulToplantisi />} />
        </Route>

        <Route path="odul-oneri" element={<OdulOneriIkRoute />}>
          <Route path="ik-takip" element={<IKTakipRapor />} />
          <Route path="ik-config" element={<IKConfig />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </>
)
